import { startAutoFlush, type AutoFlushOptions } from './auto'
import { createQueue, type QueuedAction, type Sender } from './queue'

/** Общая очередь приложения (IndexedDB 'dalat-offline'). */
export const queue = createQueue()

export const enqueue = (action: Omit<QueuedAction, 'createdAt'> & { createdAt?: string }) => queue.enqueue(action)
export const size = () => queue.size()
export const list = () => queue.list()
export const clear = () => queue.clear()
export const subscribe = (cb: (size: number) => void) => queue.subscribe(cb)
export const flush = (sender: Sender) => queue.flush(sender)
export const autoFlush = (sender: Sender, opts?: AutoFlushOptions) => startAutoFlush(queue, sender, opts)
